import React from "react";
import SoftSkillImg from "../assets/images/foict1 (2).png";
import ManagerSkillImg from "../assets/images/foict1 (1).png";
import job from "../assets/images/foict1.png";
import { Link } from "react-router-dom";


const skills = [
  {
    title: "Soft Skills Mastery",
    description: [
      "Speak clearly and confidently in all settings.",
      "Build emotional intelligence and adaptability.",
      "Improve communication in interviews and teamwork.",
      "Essential for professionals at every level.",
    ],
    cta: "Explore Soft Skills",
    img: SoftSkillImg,
    reverse: false,
  },
  {
    title: "Advanced Manager Skills",
    description: [
      "Lead teams with empathy and clarity.",
      "Make decisions under pressure.",
      "Manage performance and drive results.",
      "For both new and seasoned managers.",
    ],
    cta: "Grow as a Manager",
    img: ManagerSkillImg,
    reverse: true,
  },
  {
    title: "Advanced Successful Job Hunt",
    description: [
      "Create standout resumes and cover letters.",
      "Ace interviews with real-time simulations.",
      "Master online job platforms and networking.",
      "Designed for job seekers of all industries.",
    ],
    cta: "Boost Your Job Hunt",
    img: job,
    reverse: false,
  },
];

export default function FoictSkillSection() {
  return (
    <section className="px-4 md:px-6 lg:px-10 py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto space-y-20">
        {/* Main Heading */}
        <div className="text-center">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#fc3c04] mb-4">
            Don’t Scroll. Skill Smart. <span className="text-[#345bf3]"> Get Sharp.</span>
          </h2>
          <p className="text-gray-600 text-lg">
            We provide these professional skills to power your career journey.
          </p>
        </div>

        {/* Skill Sections */}
        {skills.map((skill, index) => (
          <div
            key={index}
            className={`flex flex-col ${
              skill.reverse ? "md:flex-row-reverse" : "md:flex-row"
            } items-center gap-10 md:gap-14`}
          >
            {/* Image */}
            <div className="w-full md:w-1/2">
              <img
                src={skill.img}
                alt={skill.title}
                className="rounded-xl shadow-lg w-full max-w-[500px] object-cover"
              />
            </div>

            {/* Content */}
            <div className="w-full md:w-1/2 space-y-5">
              <h3 className="text-2xl lg:text-3xl font-bold text-[#fc3c04]">
                {skill.title}
              </h3>
              <ul className="text-gray-700 text-base lg:text-lg space-y-2 list-disc pl-5">
                {skill.description.map((line, i) => (
                  <li key={i}>{line}</li>
                ))}
              </ul>
              <Link to={"/courses"} className="px-5 py-2 bg-[#345bf3] text-white rounded-full hover:bg-[#fc3c04] hover:text-white transition text-sm font-medium">
                {skill.cta}
              </Link>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
